module.exports = __webpack_public_path__ + "img/3_144.ee3a6a51.png";